import { type UUID } from '~/types/common';

import { emptyDashboardFilterGroup } from './emptyDashboardFilterGroup';

const createFilters = (
  isEmptyFilterGroup: boolean,
  filterValues: Record<string, any>,
) => {
  const keys = Object.keys(emptyDashboardFilterGroup);

  const filters = {};
  for (const key of keys) {
    filters[key] = isEmptyFilterGroup ? [] : filterValues[key];
  }

  return filters;
};

/**
 * Returns a filter group object based on the provided parameters.
 */
export const getFilterGroupObject = ({
  filterGroupId,
  filterGroupName,
  filterGroups,
  filterRows = [],
  filterValues,
  isEmptyFilterGroup,
}: {
  filterGroupId: UUID;
  filterGroupName?: string;
  filterGroups: Array<Record<string, any>>;
  filterRows?: Array<Record<string, any>>;
  filterValues: Record<string, any>;
  isEmptyFilterGroup: boolean;
}) => {
  const filterGroup = filterGroups?.find(({ id }) => id === filterGroupId);

  let newFilterRows = [...filterRows];

  if (newFilterRows.length === 0 && filterGroup) {
    newFilterRows = Array.isArray(filterGroup.filterRows)
      ? [...filterGroup.filterRows]
      : [];
  }

  const filterGroupObject = {
    filterRows: newFilterRows,
    filters: createFilters(isEmptyFilterGroup, filterValues),
    id: filterGroupId,
    name: filterGroupName ?? filterGroup?.name,
  };

  return filterGroupObject;
};
